import { render, staticRenderFns } from "./menu-bar.vue?vue&type=template&id=1cd8be38&scoped=true&"
import script from "./menu-bar.vue?vue&type=script&lang=js&"
export * from "./menu-bar.vue?vue&type=script&lang=js&"
import style0 from "./menu-bar.vue?vue&type=style&index=0&id=1cd8be38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd8be38",
  null
  
)

export default component.exports